<template>
  <div>
    <login :show.sync="show" :jtype="jtype"></login>
    <div class="index-banner">
      <ivideo></ivideo>
      <div class="w-100 oflow index-search-par">
        <div class="index-banner-text"></div>
        <div class="wd-1200px mar-0auto">
          <div class="flex-layout index-search">
            <div :class="type=='pro'?'index-search-tag1':'index-search-tag'">
              <a href="javascript:;" :class="type=='pro'?'pos-r font16 index-search-tag-title fontb fontB':'pos-r font16 index-search-tag-title fontB'" @click="changeType('pro','来自全球的优质科创项目')">项目</a>
             </div>
             <div :class="type=='exp'?'index-search-tag1 mar-left5':'index-search-tag mar-left5'">
              <a href="javascript:;" :class="type=='exp'?'pos-r font16 index-search-tag-title fontB':'pos-r font16 index-search-tag-title fontB'" @click="changeType('exp','数百位专家为您解决技术痛点')">专家</a>
             </div>
             <div :class="type=='res'?'index-search-tag1 mar-left5':'index-search-tag mar-left5'">
              <a href="javascript:;" :class="type=='res'?'pos-r font16 index-search-tag-title fontB':'pos-r font16 index-search-tag-title fontB'" @click="changeType('res','项目融资不用愁')">资本</a>
             </div>
             <div :class="type=='inf'?'index-search-tag1 mar-left5':'index-search-tag mar-left5'">
              <a href="javascript:;" :class="type=='inf'?'pos-r font16 index-search-tag-title fontB':'pos-r font16 index-search-tag-title fontB'" @click="changeType('inf','最新最热的政策头条')">政策</a>
             </div>
          </div>
          <div class="flex-layout w-65 pad20 index-search-con">
             <input type="text" v-model="searchWord" :placeholder="holder" maxlength="30" class="border0 h-30px font18 c-ffffff w-85 index-search-con-input">
             <button class="pad-left5 font18 c-ffffff index-search-con-btn" @click="toSearch()"><img src="../assets/img/index/index_search.png" alt="">&nbsp;&nbsp;</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 国家专区 -->
    <div class="state-banner">
      <div class="wd-1200px mar-0auto">
        <div class="flex-layout-column flex-v-align-center">
          <p class="fz36 mar-top55">国际专区</p>
          <img src="../assets/img/index/index_icon.png" alt="" width="167" height="11" class="mar-top25">
        </div>
        <div class="mar-top55">
             <div class="bd-top-dedede  wd-1200px">
               <div class="fl pos-r" style="width:150px;height:41px" v-for="(item,index) in citys">
                 <div class="pos-a w-100">
                    <a href="javascript:;" :class="cindex==index?'bgc-522e95 state-tag fl bd-right-dedede pad-10auto font16 tac c-ffffff':'bgc-e5e5e5 state-tag fl bd-right-dedede pad-10auto font16 tac'" @mouseover="countrySel(index)">{{item.areaName}}</a>
                  </div>
               </div>
             </div>
             <div v-for="(item,index) in citys" v-if="cindex==index" class="cursor">
               <img :src="item.logo" width="100%" height="320" @click="toArea(item.areaId)" :title="item.areaName">
             </div>
        </div>
      </div>
    </div>
    <!-- 技术项目 -->
    <div class="techny-banner">
      <div class="wd-1200px mar-0auto">
        <div class="flex-layout-column flex-v-align-center">
          <p class="fz36 mar-top55">技术项目一站式对接平台</p>
          <img src="../assets/img/index/index_icon.png" alt="" width="167" height="11" class="mar-top25">
        </div>
        <div class="techny-content-banner mar-top55">
          <div class="techny-botton-left">
            <a href="javascript:;" class="bgc-jb2" @click="toRelease_pro()"></a>
          </div>
          <div class="techny-botton-right">
            <a href="javascript:;" class="bgc-jb2" @click="toRelease_dem()"></a>
          </div>
        </div>
      </div>
    </div>
    <!-- 动态报道，成功案例... -->
    <div class="bgc-ffffff">
      <div class="wd-1200px mar-0auto">
        <div class="flex-layout">
          <div class="flex-layout-column flex-v-align-center info-content-item">
            <p class="fz30 mar-top65">动态报道</p>
            <img src="../assets/img/index/index_icon_small.png" alt="" width="133" height="7" class="mar-top10">
            <div class="mar-top35 w-100 info-content-item-shadow">
              <div class="swiper-box">
                <swiper ref="swiperOption" :options="swiperOption" v-if="repList && repList.length>0">
                  <swiper-slide class="swiper-slide" v-for="(item,index) in repList" :key="item.uuid">
                      <div class="w-100 info-content-item-ppt cursor" @click="toRep(item.uuid)"><img :src="item.img"/></div>
                      <div class="pad-left15 pad-right15 pad-top20 pad-bottom35 bgc-f4f3fd bd-top-f0f0f0">
                         <p class="ovfw w-95 font18 c-ff880b cursor fontB" @click="toRep(item.uuid)">{{item.title}}</p>
                         <p class="ovfw2 w-95 mar-top15 font14 c-666666 h-38px">{{item.summary}}</p>
                      </div>
                  </swiper-slide>
                  <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
              </div>
            </div>
            <button class="mar-top35 pad-top5 pad-bottom5 pad-left10 pad-right10 mar-bottom45 radius4 border0 bgc-522e95 c-ffffff font12" @click="toRepList()">MORE</button>
          </div>
         <!--  <div class="flex-layout-column flex-v-align-center info-content-item mar-auto25">
            <p class="fz30 mar-top65">成功案例</p>
            <img src="../assets/img/index/index_icon_small.png" alt="" width="133" height="7" class="mar-top10">
            <div class="mar-top35 w-100 info-content-item-shadow">
                <div class="swiper-box">
                  <swiper ref="swiperOption" :options="swiperOption" v-if="caseList && caseList.length>0">
                    <swiper-slide class="swiper-slide" v-for="(item,index) in caseList" :key="item.uuid">
                        <div class="w-100 info-content-item-ppt cursor" @click="toCase(item.uuid)"><img :src="item.img"/></div>
                        <div class="pad-left15 pad-right15 pad-top20 pad-bottom35 bgc-f4f3fd bd-top-f0f0f0">
                           <p class="ovfw w-95 font18 c-ff880b cursor fontB" @click="toCase(item.uuid)">{{item.title}}</p>
                           <p class="ovfw2 w-95 mar-top15 font14 c-666666 h-38px">{{item.summary}}</p>
                        </div>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                  </swiper>
                </div>
            </div>
            <button class="mar-top35 pad-top5 pad-bottom5 pad-left10 pad-right10 mar-bottom45 radius4 border0 bgc-522e95 c-ffffff font12" @click="toCaseList()">MORE</button>
          </div>
          <div class="flex-layout-column flex-v-align-center info-content-item">
            <p class="fz30 mar-top65">项目路演</p>
            <img src="../assets/img/index/index_icon_small.png" alt="" width="133" height="7" class="mar-top10">
            <div class="mar-top35 w-100 info-content-item-shadow">
                <div class="swiper-box">
                  <swiper ref="swiperOption" :options="swiperOption" v-if="showList && showList.length>0">
                    <swiper-slide class="swiper-slide" v-for="(item,index) in showList" :key="item.uuid">
                        <div class="w-100 info-content-item-ppt cursor" @click="toShow(item.uuid)"><img :src="item.indexPhoto"/></div>
                        <div class="pad-left15 pad-right15 pad-top20 pad-bottom35 bgc-f4f3fd bd-top-f0f0f0">
                           <p class="ovfw w-95 font18 c-ff880b cursor fontB" @click="toShow(item.uuid)">{{item.title}}</p>
                           <p class="ovfw2 w-95 mar-top15 font14 c-666666 h-38px">{{item.lightspot | cutWords(40)}}</p>
                        </div>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                  </swiper>
               </div>
            </div>
            <button class="mar-top35 pad-top5 pad-bottom5 pad-left10 pad-right10 mar-bottom45 radius4 border0 bgc-522e95 c-ffffff font12" @click="toShowList()">MORE</button>
          </div> -->
			<div class="flex-layout-column flex-v-align-center info-content-item mar-auto25">
			  <p class="fz30 mar-top65">科技前沿</p>
			  <img src="../assets/img/index/index_icon_small.png" alt="" width="133" height="7" class="mar-top10">
			  <div class="mar-top35 w-100 info-content-item-shadow">
			      <div class="swiper-box">
			        <swiper ref="swiperOption" :options="swiperOption" v-if="caseList && caseList.length>0">
			          <swiper-slide class="swiper-slide" v-for="(item,index) in caseList" :key="item.uuid">
			              <div class="w-100 info-content-item-ppt cursor" @click="toFront(item.uuid)"><img :src="item.img"/></div>
			              <div class="pad-left15 pad-right15 pad-top20 pad-bottom35 bgc-f4f3fd bd-top-f0f0f0">
			                 <p class="ovfw w-95 font18 c-ff880b cursor fontB" @click="toFront(item.uuid)">{{item.title}}</p>
			                 <p class="ovfw2 w-95 mar-top15 font14 c-666666 h-38px">{{item.summary}}</p>
			              </div>
			          </swiper-slide>
			          <div class="swiper-pagination" slot="pagination"></div>
			        </swiper>
			      </div>
			  </div>
			  <button class="mar-top35 pad-top5 pad-bottom5 pad-left10 pad-right10 mar-bottom45 radius4 border0 bgc-522e95 c-ffffff font12" @click="toFrontList()">MORE</button>
			</div>		
		<div class="flex-layout-column flex-v-align-center info-content-item">
		  <p class="fz30 mar-top65">创投资讯</p>
		  <img src="../assets/img/index/index_icon_small.png" alt="" width="133" height="7" class="mar-top10">
		  <div class="mar-top35 w-100 info-content-item-shadow">
			  <div class="swiper-box">
				<swiper ref="swiperOption" :options="swiperOption" v-if="showList && showList.length>0">
				  <swiper-slide class="swiper-slide" v-for="(item,index) in showList" :key="item.uuid">
					  <div class="w-100 info-content-item-ppt cursor" @click="toVenture(item.uuid)"><img :src="item.img"/></div>
					  <div class="pad-left15 pad-right15 pad-top20 pad-bottom35 bgc-f4f3fd bd-top-f0f0f0">
						 <p class="ovfw w-95 font18 c-ff880b cursor fontB" @click="toVenture(item.uuid)">{{item.title}}</p>
						 <p class="ovfw2 w-95 mar-top15 font14 c-666666 h-38px">{{item.summary}}</p>
					  </div>
				  </swiper-slide>
				  <div class="swiper-pagination" slot="pagination"></div>
				</swiper>
			 </div>
		  </div>
		  <button class="mar-top35 pad-top5 pad-bottom5 pad-left10 pad-right10 mar-bottom45 radius4 border0 bgc-522e95 c-ffffff font12" @click="toVentureList()">MORE</button>
		</div>
        </div>
      </div>
    </div>

    <!-- 政策头条 -->
    <div class="policy-banner">
      <div class="wd-1200px mar-0auto">
        <div class="flex-layout-column flex-v-align-center">
          <p class="fz36 mar-top55">政策头条</p>
          <img src="../assets/img/index/index_icon.png" alt="" width="167" height="11" class="mar-top25">
        </div>
        <div class="flex-layout mar-top20 policy-left-list-par">
          <!-- 左边列表 -->
          <div class="bgc-ffffff policy-left-list-content">
            <!-- tab栏 -->
            <div class="flex-layout pad-left30 pad-right30 pad-top30 flex-v-align-bottom flex-h-align-between bgc-ffffff policy-left-list-content-tab">
             <div>
				 <span class="font24 mar-bottom10">最新政策</span>
				 <router-link :to="{path:'/choice/list'}" class="font16 mar-bottom10 c-522e95 mar-left20 fontB">政策精编</router-link>
			 </div>
              <p class="font16 flex-layout flex-v-align-center pos-r" style="top: 2px;">
                <span :class="info=='shi'?'c-522e95 pad-bottom10 policy-left-list-content-tab-sel mar-right50':'mar-right50 pad-bottom10'"><a href="javascript:;" @click="infoChange('shi')">东莞市</a></span>
                <span :class="info=='she'?'c-522e95 pad-bottom10 policy-left-list-content-tab-sel':'pad-bottom10'"><a href="javascript:;" @click="infoChange('she')">省级</a></span>
                <span :class="info=='guo'?'c-522e95 pad-bottom10 policy-left-list-content-tab-sel mar-left50':'mar-left50 pad-bottom10'"><a href="javascript:;" @click="infoChange('guo')">国家级</a></span>
                <router-link :to="{path:'/info/list'}" class="mar-left100 pad-bottom10">更多&nbsp;></router-link>
              </p>
            </div>
            <!-- 列表 -->
            <div class="flex-layout flex-layout-column mar-top15">
              <div v-if="!shiData">
                <div class="bgc-ffffff pad-left30 pad-right30" v-for="item in shiList" v-if="info=='shi'">
                  <div class="flex-layout flex-h-align-between font16 c-666666 pad-15auto bd-bottom-dedede-dotted">
                    <p class="flex-layout flex-v-align-center">
                      <span class=" disL badge-dot bgc-393939 mar-right5"></span>
                      <img src="../assets/img/info/new.png" class="mar-left10" alt="">
                      <router-link :to="{path:'/info/detail',query:{id:item.uuid}}" class="mar-left5">{{item.title | cutWords(40)}}</router-link>
                    </p>
                    <p><span>{{item.releaseDate | formatTime('d')}}</span></p>
                  </div>
                </div>
              </div>
              <div v-if="shiData && info=='shi'" class="noList"><p>暂时没有数据</p></div>

              <div v-if="!sheData">
                <div class="bgc-ffffff pad-left30 pad-right30" v-for="item in sheList" v-if="info=='she'">
                  <div class="flex-layout flex-h-align-between font16 c-666666 pad-15auto bd-bottom-dedede-dotted">
                    <p class="flex-layout flex-v-align-center">
                      <span class=" disL badge-dot bgc-393939 mar-right5"></span>
                      <img src="../assets/img/info/new.png" class="mar-left10" alt="">
                      <router-link :to="{path:'/info/detail',query:{id:item.uuid}}" class="mar-left5">{{item.title | cutWords(40)}}</router-link>
                    </p>
                    <p><span>{{item.releaseDate | formatTime('d')}}</span></p>
                  </div>
                  </div>
                </div>
                <div v-if="sheData && info=='she'" class="noList"><p>暂时没有数据</p></div>

                <div v-if="!guoData">
                  <div class="bgc-ffffff pad-left30 pad-right30" v-for="item in guoList" v-if="info=='guo'">
                    <div class="flex-layout flex-h-align-between font16 c-666666 pad-15auto bd-bottom-dedede-dotted">
                      <p class="flex-layout flex-v-align-center length-auto">
                        <span class=" disL badge-dot bgc-393939 mar-right5"></span>
                        <img src="../assets/img/info/new.png" class="mar-left10" alt="">
                        <router-link :to="{path:'/info/detail',query:{id:item.uuid}}" class="mar-left5">{{item.title | cutWords(40)}}</router-link>
                      </p>
                      <p><span>{{item.releaseDate | formatTime('d')}}</span></p>
                    </div>
                  </div>
                </div>
                <div v-if="guoData && info=='guo'" class="noList"><p>暂时没有数据</p></div>
            </div>
          </div>
          <!-- 右边订阅 -->
          <div class="bgc-jb4 policy-right">
            <!-- 标题 -->
            <div class="flex-layout pad-left30 pad-right30 pad-top30 flex-v-align-bottom flex-h-align-between policy-left-list-content-tab">
              <span class="font24 mar-bottom10">订阅政策</span>
              <span class="font16 mar-bottom10"><a href="javascript:;" @click="toSub()">一键订阅</a></span>
             </div>
             <!-- 内容 -->
             <div class="pad-top10 pad-left15 pad-right15 pad-bottom40 flex-layout-column flex-v-align-center">
               <img src="../assets/img/index/sub.jpg" width="295" height="190" alt="">
               <p class="tac font16 c-222222 mar-top35">每天09:00整，准时推送政策</p>
               <button class="pad-left20 pad-right20 pad-top5 pad-bottom5 radius5 c-522e95 font16 mar-top20 policy-right-content-btn" @click="toSub()">马上订阅</button>
             </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务网络 -->
    <div class="bgc-ffffff">
      <div class="wd-1200px mar-0auto">
        <div class="flex-layout-column flex-v-align-center">
          <p class="fz36 mar-top55">“政-产-学-研-资-介”六大服务网络</p>
          <img src="../assets/img/index/index_icon.png" alt="" width="167" height="11" class="mar-top25">
        </div>
        <div class="ffwlBox mar-top40 mar-bottom40">
          <div class="ffwlItem1 fl"><div class="ffwl_Item_1"></div></div>
          <div class="ffwlItem2 fl"><div class="ffwl_Item_2"></div></div>
          <div class="ffwlItem3 fl"><div class="ffwl_Item_3"></div></div>
          <div class="ffwlItem4 fl"><div class="ffwl_Item_4"></div></div>
          <div class="ffwlItem5 fl"><div class="ffwl_Item_5"></div></div>
          <div class="ffwlItem6 fl"><div class="ffwl_Item_6"></div></div>
        </div>
      </div>
    </div>

    <div class="index-map mar-top70">
      <div class="wd-1200px pos-r mar-0auto" style="height:854px;min-width:1200px;">
        <div class="map_az">
          <div class="hoverPoint map_az_point" @mouseover="mapShow('map_az_show')" @mouseleave="mapHide('map_az_show')">
				<div class="mapShow" v-if="map_az_show">
					 <i></i>
					 <div class="mapShow_box">
						 <p class="tac fontB c-8d85cb font16">澳大利亚</p>
						 <div class="tal mar-top10">
							 <p class="pad-bottom10 tac" v-for="item in map_az_data">{{item.orgnName}}</p>
						 </div>
					 </div>
				</div>
			</div>
        </div>

        <div class="map_bx">
          <div class="hoverPoint map_bx_point" @mouseover="mapShow('map_bx_show')" @mouseleave="mapHide('map_bx_show')">
			  <div class="mapShow" v-if="map_bx_show">
				 <i></i>
				 <div class="mapShow_box">
				   <p class="tac fontB c-8d85cb font16">巴西</p>
				   <div class="tal mar-top10">
					 <p class="pad-bottom10 tac" v-for="item in map_bx_data">{{item.orgnName}}</p>
				   </div>
				 </div>
			  </div>
		  </div>
        </div>
        <div class="map_els">
          <div class="hoverPoint map_els_point" @mouseover="mapShow('map_els_show')" @mouseleave="mapHide('map_els_show')">
			  <div class="mapShow" v-if="map_els_show">
				 <i></i>
				 <div class="mapShow_box">
				   <p class="tac fontB c-8d85cb font16">俄罗斯</p>
				   <div class="tal mar-top10">
					 <p class="pad-bottom10 tac" v-for="item in map_els_data">{{item.orgnName}}</p>
				   </div>
				 </div>
			  </div>
		  </div>
        </div>
        <div class="map_fl">
          <div class="hoverPoint map_fl_point" @mouseover="mapShow('map_fl_show')" @mouseleave="mapHide('map_fl_show')">
			  <div class="mapShow" v-if="map_fl_show">
				 <i></i>
				 <div class="mapShow_box">
				   <p class="tac fontB c-8d85cb font16">芬兰</p>
				   <div class="tal mar-top10">
					 <p class="pad-bottom10 tac" v-for="item in map_fl_data">{{item.orgnName}}</p>
				   </div>
				 </div>
			  </div>
		  </div>
        </div>
        <div class="map_jnd">
          <div class="hoverPoint map_jnd_point" @mouseover="mapShow('map_jnd_show')" @mouseleave="mapHide('map_jnd_show')">
			  <div class="mapShow" v-if="map_jnd_show">
				 <i></i>
				 <div class="mapShow_box">
				   <p class="tac fontB c-8d85cb font16">加拿大</p>
				   <div class="tal mar-top10">
					 <p class="pad-bottom10 tac" v-for="item in map_jnd_data">{{item.orgnName}}</p>
				   </div>
				 </div>
			  </div>
		  </div>
        </div>
        <div class="map_rb">
          <div class="hoverPoint map_rb_point" @mouseover="mapShow('map_rb_show')" @mouseleave="mapHide('map_rb_show')">
			  <div class="mapShow" v-if="map_rb_show">
				 <i></i>
				 <div class="mapShow_box">
				   <p class="tac fontB c-8d85cb font16">日本</p>
				   <div class="tal mar-top10">
					 <p class="pad-bottom10 tac" v-for="item in map_rb_data">{{item.orgnName}}</p>
				   </div>
				 </div>
			  </div>
		  </div>
        </div>
        <div class="map_rs">
          <div class="hoverPoint map_rs_point" @mouseover="mapShow('map_rs_show')" @mouseleave="mapHide('map_rs_show')">
			  <div class="mapShow" v-if="map_rs_show">
				 <i></i>
				 <div class="mapShow_box">
				   <p class="tac fontB c-8d85cb font16">瑞士</p>
				   <div class="tal mar-top10">
					 <p class="pad-bottom10 tac" v-for="item in map_rs_data">{{item.orgnName}}</p>
				   </div>
				 </div>
			  </div>
		  </div>
        </div>
        <div class="map_xby">
          <div class="hoverPoint map_xby_point" @mouseover="mapShow('map_xby_show')" @mouseleave="mapHide('map_xby_show')">
			  <div class="mapShow" v-if="map_xby_show">
				 <i></i>
				 <div class="mapShow_box">
				   <p class="tac fontB c-8d85cb font16">西班牙</p>
				   <div class="tal mar-top10">
					 <p class="pad-bottom10 tac" v-for="item in map_xby_data">{{item.orgnName}}</p>
				   </div>
				 </div>
			  </div>
		  </div>
        </div>
        <div class="map_xg">
          <div class="hoverPoint map_xg_point" @mouseover="mapShow('map_xg_show')" @mouseleave="mapHide('map_xg_show')">
			  <div class="mapShow" v-if="map_xg_show">
				 <i></i>
				 <div class="mapShow_box">
				   <p class="tac fontB c-8d85cb font16">中国香港</p>
				   <div class="tal mar-top10">
					 <p class="pad-bottom10 tac" v-for="item in map_xg_data">{{item.orgnName}}</p>
				   </div>
				 </div>
			  </div>
		  </div>
        </div>
        <div class="map_xjp">
          <div class="hoverPoint map_xjp_point" @mouseover="mapShow('map_xjp_show')" @mouseleave="mapHide('map_xjp_show')">
			  <div class="mapShow" v-if="map_xjp_show">
				 <i></i>
				 <div class="mapShow_box">
				   <p class="tac fontB c-8d85cb font16">新加坡</p>
				   <div class="tal mar-top10">
					 <p class="pad-bottom10 tac" v-for="item in map_xjp_data">{{item.orgnName}}</p>
				   </div>
				 </div>
			  </div>
		  </div>
        </div>
        <div class="map_yg">
          <div class="hoverPoint map_yg_point" @mouseover="mapShow('map_yg_show')" @mouseleave="mapHide('map_yg_show')">
			  <div class="mapShow" v-if="map_yg_show">
				 <i></i>
				 <div class="mapShow_box">
				   <p class="tac fontB c-8d85cb font16">英国</p>
				   <div class="tal mar-top10">
					 <p class="pad-bottom10 tac" v-for="item in map_yg_data">{{item.orgnName}}</p>
				   </div>
				 </div>
			  </div>
		  </div>
        </div>
        <div class="map_yl">
          <div class="hoverPoint map_yl_point" @mouseover="mapShow('map_yl_show')" @mouseleave="mapHide('map_yl_show')">
			  <div class="mapShow" v-if="map_yl_show">
				 <i></i>
				 <div class="mapShow_box">
				   <p class="tac fontB c-8d85cb font16">伊朗</p>
				   <div class="tal mar-top10">
					 <p class="pad-bottom10 tac" v-for="item in map_yl_data">{{item.orgnName}}</p>
				   </div>
				 </div>
			  </div>
		  </div>
        </div>
        <div class="map_ysl">
          <div class="hoverPoint map_ysl_point" @mouseover="mapShow('map_ysl_show')" @mouseleave="mapHide('map_ysl_show')">
			  <div class="mapShow" v-if="map_ysl_show">
				 <i></i>
				 <div class="mapShow_box">
				   <p class="tac fontB c-8d85cb font16">以色列</p>
				   <div class="tal mar-top10">
					 <p class="pad-bottom10 tac" v-for="item in map_ysl_data">{{item.orgnName}}</p>
				   </div>
				 </div>
			  </div>
		  </div>
        </div>
        <div class="map_hg">
          <div class="hoverPoint map_hg_point" @mouseover="mapShow('map_hg_show')" @mouseleave="mapHide('map_hg_show')">
			  <div class="mapShow" v-if="map_hg_show">
				 <i></i>
				 <div class="mapShow_box">
				   <p class="tac fontB c-8d85cb font16">韩国</p>
				   <div class="tal mar-top10">
					 <p class="pad-bottom10 tac" v-for="item in map_hg_data">{{item.orgnName}}</p>
				   </div>
				 </div>
			  </div>
		  </div>
        </div>
        <div class="map_mg">
          <div class="hoverPoint map_mg_point" @mouseover="mapShow('map_mg_show')" @mouseleave="mapHide('map_mg_show')">
			  <div class="mapShow" v-if="map_mg_show">
				 <i></i>
				 <div class="mapShow_box">
				   <p class="tac fontB c-8d85cb font16">美国</p>
				   <div class="tal mar-top10">
					 <p class="pad-bottom10 tac" v-for="item in map_mg_data">{{item.orgnName}}</p>
				   </div>
				 </div>
			  </div>
		  </div>
        </div>
      </div>
    </div>

    <bottom></bottom>
  </div>
</template>

<script>
  import bottom from '../components/common/bottom.vue';
  import ivideo from '../components/common/video.vue';
  import login from '../components/common/login.vue';
  import { swiper, swiperSlide} from 'vue-awesome-swiper';
  import {isMobile} from '../utils/isMobile.js'
  require('swiper/dist/css/swiper.min.css')
  export default {
    name: 'index',
    data () {
      return {
        type:'pro',
        searchWord:'',
        holder:'来自全球的优质科创项目',
        repList:'',
        caseList:'',
        showList:'',
        shiList:'',
        sheList:'',
        guoList:'',
        citys:'',
        isLogin:'',
        cindex:0,
        title:'',
        info:'shi',
        metaData:[],
        shiData:false,
        sheData:false,
        guoData:false,
        swiperOption: {
          pagination: {
            el: '.swiper-pagination',
            clickable:true,
          },autoplay: {
      　　  delay: 5000,
      　　  disableOnInteraction: false
      　　},
          loop: true,
        },
        show: false,
        jtype: '',
        map_az_show:false,
        map_az_data:[],
        map_bx_show:false,
        map_bx_data:[],
        map_els_show:false,
        map_els_data:[],
        map_fl_show:false,
        map_fl_data:[],
        map_jnd_show:false,
        map_jnd_data:[],
        map_rb_show:false,
        map_rb_data:[],
        map_rs_show:false,
        map_rs_data:[],
        map_xby_show:false,
        map_xby_data:[],
        map_xg_show:false,
        map_xg_data:[],
        map_xjp_show:false,
        map_xjp_data:[],
        map_yg_show:false,
        map_yg_data:[],
        map_yl_show:false,
        map_yl_data:[],
        map_ysl_show:false,
        map_ysl_data:[],
        map_hg_show:false,
        map_hg_data:[],
        map_mg_show:false,
        map_mg_data:[],
      }
    },
    created () {

      if(isMobile()){
        window.location.href = this.global.mobile+'toMobileIndex'
      }

      this.initSeo();
    },metaInfo(){
      return {
       title:this.title,
       meta:this.metaData
      }
    },
    mounted () {
      //window.addEventListener('scroll', this.indexScroll);

      this.$axios.get(this.global.url+'index/index').then( res => {
        this.repList = res.data.repList;
        this.caseList = res.data.caseList;
        this.showList = res.data.showList;
        this.isLogin = res.data.isLogin;
        if(res.data.shiList && res.data.shiList.length>0){
          this.shiList = res.data.shiList;
          this.shiData = false;
        }else{
          this.shiData = true;
        }
        if(res.data.sheList && res.data.sheList.length>0){
          this.sheList = res.data.sheList;
          this.sheData = false;
        }else{
          this.sheData = true;
        }
        if(res.data.guoList && res.data.guoList.length>0){
          this.guoList = res.data.guoList;
          this.guoData = false;
        }else{
          this.guoData = true;
        }
      });

      this.$axios.get(this.global.url+'parame/area').then( res => {
        this.citys = res.data.areaList;
      });
    },
    components:{bottom,ivideo,swiper,swiperSlide,login},
    methods:{
      initSeo() {
        this.title = this.global.webName
        this.metaData = [
            {Description:this.global.webName},
            {Keywords:this.global.webName},
            {content: 'width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0'}
          ]
      }/* ,indexScroll(){
        // 页面滚动距顶部距离
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
                document.body.scrollTop
        var scroll = scrollTop - this.i;
        this.i = scrollTop;
        const windowHeight = document.documentElement.clientHeight
        if(scroll<0){//up
          if(scrollTop<=windowHeight){
            document.documentElement.scrollTop-=30;
          }
        }else if(scroll>0){//down
          if(scrollTop<windowHeight){
            document.documentElement.scrollTop+=30;
          }
        }else{
          if(scrollTop<=200){
            document.documentElement.scrollTop+=30;
          }else{
            document.documentElement.scrollTop-=30;
          }
        }
      } */,changeType(type,text){
        this.type = type;
        this.holder = text;
      },toSearch(){
        if(this.type=='pro'){
          this.$router.push({path:"/resource/list",query:{word:this.searchWord}})
        }else if(this.type=='exp'){
          this.$router.push({path:"/expert/list",query:{word:this.searchWord}})
        }else if(this.type=='res'){
          this.$router.push({path:"/orgn/list",query:{word:this.searchWord}})
        }else if(this.type=='inf'){
          this.$router.push({path:"/info/list",query:{word:this.searchWord}})
        }
      },toArea(id){
        this.$router.push({path:"/resource/list",query:{id:id}})
      },countrySel(index){
        this.cindex = index;
      },toCase(id){
        this.$router.push({path:"/case/detail",query:{id:id}})
      },toShow(id){
        this.$router.push({path:"/show/detail",query:{id:id}})
      },toFront(id){
        this.$router.push({path:"/front/detail",query:{id:id}})
      },toVenture(id){
        this.$router.push({path:"/venture/detail",query:{id:id}})
      },toRep(id){
        this.$router.push({path:"/about/dyReportsDetail",query:{id:id}})
      },toCaseList(){
        this.$router.push({path:"/case/list"})
      },toShowList(){
        this.$router.push({path:"/show/list"})
      },toRepList(){
        this.$router.push({path:"/about/dyReportsList"})
      },toFrontList(){
        this.$router.push({path:"/front/list"})
      },toVentureList(){
        this.$router.push({path:"/venture/list"})
      },infoChange(info){
        this.info = info;
      },open () {
        this.show = true;
      },toRelease_pro(){
        if(this.isLogin){
          this.$router.push({path:"/user/projectAdd"})
        }else{
          this.show = true;
          this.jtype = 'projectAdd'
        }
      },toRelease_dem(){
        if(this.isLogin){
          this.$router.push({path:"/user/projectDemAdd"})
        }else{
          this.show = true;
          this.jtype = 'projectDemAdd'
        }
      },toSub(){
        if(this.isLogin){
          this.$router.push({path:"/info/sub"})
        }else{
          this.show = true;
          this.jtype = 'sub'
        }
      },mapShow(obj){
        var id;
				this.mapHide(obj);
        if(obj=='map_az_show'){
          if(!this.map_az_data || this.map_az_data.length<1){
            this.$axios.get(this.global.url+'parame/orgn',{
              params:{
                areaName:'澳大利亚'
              }
            }).then( res => {
              this.map_az_data = res.data.list
              if(this.map_az_data && this.map_az_data.length>0){
                this.map_az_show = true
              }
            });
          }else{
            this.map_az_show = true
          }
        }else if(obj=='map_bx_show'){
          if(!this.map_bx_data || this.map_bx_data.length<1){
            this.$axios.get(this.global.url+'parame/orgn',{
              params:{
                areaName:'巴西'
              }
            }).then( res => {
              this.map_bx_data = res.data.list
              if(this.map_bx_data && this.map_bx_data.length>0){
                this.map_bx_show = true
              }
            });
          }else{
            this.map_bx_show = true
          }
        }else if(obj=='map_els_show'){
          if(!this.map_els_data || this.map_els_data.length<1){
            this.$axios.get(this.global.url+'parame/orgn',{
              params:{
                areaName:'俄罗斯'
              }
            }).then( res => {
              this.map_els_data = res.data.list
              if(this.map_els_data && this.map_els_data.length>0){
                this.map_els_show = true
              }
            });
          }else{
            this.map_els_show = true
          }
        }else if(obj=='map_fl_show'){
          if(!this.map_fl_data || this.map_fl_data.length<1){
            this.$axios.get(this.global.url+'parame/orgn',{
              params:{
                areaName:'芬兰'
              }
            }).then( res => {
              this.map_fl_data = res.data.list
              if(this.map_fl_data && this.map_fl_data.length>0){
                this.map_fl_show = true
              }
            });
          }else{
            this.map_fl_show = true
          }
        }else if(obj=='map_jnd_show'){
          if(!this.map_jnd_data || this.map_jnd_data.length<1){
            this.$axios.get(this.global.url+'parame/orgn',{
              params:{
                areaName:'加拿大'
              }
            }).then( res => {
              this.map_jnd_data = res.data.list
              if(this.map_jnd_data && this.map_jnd_data.length>0){
                this.map_jnd_show = true
              }
            });
          }else{
            this.map_jnd_show = true
          }
        }else if(obj=='map_rb_show'){
          if(!this.map_rb_data || this.map_rb_data.length<1){
            this.$axios.get(this.global.url+'parame/orgn',{
              params:{
                areaName:'日本'
              }
            }).then( res => {
              this.map_rb_data = res.data.list
              if(this.map_rb_data && this.map_rb_data.length>0){
                this.map_rb_show = true
              }
            });
          }else{
            this.map_rb_show = true
          }
        }else if(obj=='map_rs_show'){
          if(!this.map_rs_data || this.map_rs_data.length<1){
            this.$axios.get(this.global.url+'parame/orgn',{
              params:{
                areaName:'瑞士'
              }
            }).then( res => {
              this.map_rs_data = res.data.list
              if(this.map_rs_data && this.map_rs_data.length>0){
                this.map_rs_show = true
              }
            });
          }else{
            this.map_rs_show = true
          }
        }else if(obj=='map_xby_show'){
          if(!this.map_xby_data || this.map_xby_data.length<1){
            this.$axios.get(this.global.url+'parame/orgn',{
              params:{
                areaName:'西班牙'
              }
            }).then( res => {
              this.map_xby_data = res.data.list
              if(this.map_xby_data && this.map_xby_data.length>0){
                this.map_xby_show = true
              }
            });
          }else{
            this.map_xby_show = true
          }
        }else if(obj=='map_xg_show'){
          if(!this.map_xg_data || this.map_xg_data.length<1){
            this.$axios.get(this.global.url+'parame/orgn',{
              params:{
                areaName:'香港'
              }
            }).then( res => {
              this.map_xg_data = res.data.list
              if(this.map_xg_data && this.map_xg_data.length>0){
                this.map_xg_show = true
              }
            });
          }else{
            this.map_xg_show = true
          }
        }else if(obj=='map_xjp_show'){
          if(!this.map_xjp_data || this.map_xjp_data.length<1){
            this.$axios.get(this.global.url+'parame/orgn',{
              params:{
                areaName:'新加坡'
              }
            }).then( res => {
              this.map_xjp_data = res.data.list
              if(this.map_xjp_data && this.map_xjp_data.length>0){
                this.map_xjp_show = true
              }
            });
          }else{
            this.map_xjp_show = true
          }
        }else if(obj=='map_yg_show'){
          if(!this.map_yg_data || this.map_yg_data.length<1){
            this.$axios.get(this.global.url+'parame/orgn',{
              params:{
                areaName:'英国'
              }
            }).then( res => {
              this.map_yg_data = res.data.list
              if(this.map_yg_data && this.map_yg_data.length>0){
                this.map_yg_show = true
              }
            });
          }else{
            this.map_yg_show = true
          }
        }else if(obj=='map_yl_show'){
          if(!this.map_yl_data || this.map_yl_data.length<1){
            this.$axios.get(this.global.url+'parame/orgn',{
              params:{
                areaName:'伊朗'
              }
            }).then( res => {
              this.map_yl_data = res.data.list
              if(this.map_yl_data && this.map_yl_data.length>0){
                this.map_yl_show = true
              }
            });
          }else{
            this.map_yl_show = true
          }
        }else if(obj=='map_ysl_show'){
          if(!this.map_ysl_data || this.map_ysl_data.length<1){
            this.$axios.get(this.global.url+'parame/orgn',{
              params:{
                areaName:'以色列'
              }
            }).then( res => {
              this.map_ysl_data = res.data.list
              if(this.map_ysl_data && this.map_ysl_data.length>0){
                this.map_ysl_show = true
              }
            });
          }else{
            this.map_ysl_show = true
          }
        }else if(obj=='map_hg_show'){
          if(!this.map_hg_data || this.map_hg_data.length<1){
            this.$axios.get(this.global.url+'parame/orgn',{
              params:{
                areaName:'韩国'
              }
            }).then( res => {
              this.map_hg_data = res.data.list
              if(this.map_hg_data && this.map_hg_data.length>0){
                this.map_hg_show = true
              }
            });
          }else{
            this.map_hg_show = true
          }
        }else if(obj=='map_mg_show'){
          if(!this.map_mg_data || this.map_mg_data.length<1){
            this.$axios.get(this.global.url+'parame/orgn',{
              params:{
                areaName:'美国'
              }
            }).then( res => {
              this.map_mg_data = res.data.list
              if(this.map_mg_data && this.map_mg_data.length>0){
                this.map_mg_show = true
              }
            });
          }else{
            this.map_mg_show = true
          }
        }
      },mapHide(obj){
		 this.map_az_show = false
		 this.map_bx_show = false
		 this.map_els_show = false
		 this.map_fl_show = false
		 this.map_jnd_show = false
		 this.map_rs_show = false
		 this.map_rb_show = false
		 this.map_xby_show = false
		 this.map_xg_show = false
		 this.map_yg_show = false
		 this.map_xjp_show = false
		 this.map_yl_show = false
		 this.map_ysl_show = false
		 this.map_hg_show = false
		 this.map_mg_show = false
				
        // if(obj=='map_az_show'){
        //  this.map_az_show = false
        // }else if(obj=='map_bx_show'){
        //  this.map_bx_show = false
        // }else if(obj=='map_els_show'){
        //  this.map_els_show = false
        // }else if(obj=='map_fl_show'){
        //  this.map_fl_show = false
        // }else if(obj=='map_jnd_show'){
        //  this.map_jnd_show = false
        // }else if(obj=='map_rs_show'){
        //  this.map_rs_show = false
        // }else if(obj=='map_rb_show'){
        //  this.map_rb_show = false
        // }else if(obj=='map_xby_show'){
        //  this.map_xby_show = false
        // }else if(obj=='map_xg_show'){
        //  this.map_xg_show = false
        // }else if(obj=='map_yg_show'){
        //  this.map_yg_show = false
        // }else if(obj=='map_xjp_show'){
        //  this.map_xjp_show = false
        // }else if(obj=='map_yl_show'){
        //  this.map_yl_show = false
        // }else if(obj=='map_ysl_show'){
        //  this.map_ysl_show = false
        // }else if(obj=='map_hg_show'){
        //  this.map_hg_show = false
        // }else if(obj=='map_mg_show'){
        //  this.map_mg_show = false
        // }
      }
   },beforeDestroy() {
     window.removeEventListener("scroll",this.indexScroll)
   }
  }
</script>

<style scoped>
  @import '../assets/font/iconfont.css';
  @import '../assets/css/common-distance.css';
  @import '../assets/css/common-default.css';
  @import '../assets/css/common-color.css';
  @import '../assets/css/topAndfoot.css';
  @import '../assets/css/common-layout.css';
  @import '../assets/css/layui.css';
  @import '../assets/css/client.css';

  .swiper-container{width:380px;height:416px;}
  .swiper-box{border-top-left-radius:4px;border-top-right-radius:4px;}
  .swiper-box img{width:380px;height:285px;display:block;margin:auto;border-top-left-radius:4px;border-top-right-radius:4px;}
  .swiper-pagination{bottom:150px !important;}
  input:-ms-input-placeholder {color: #f6d29e;}
  input::-moz-placeholder {color: #f6d29e;}
  input::-moz-placeholder {color: #f6d29e;}
  input::-webkit-input-placeholder {color: #f6d29e;}
</style>
